<template>
  <component
    :is="getComponentMap(userNotification.notification.type)"
    :data="userNotification.notification.data"
    :active="userNotification.readAt === null"
    active-class="bg-deep-orange-1 text-grey-9"
    v-bind="$attrs" clickable>
    <humanize-time :time="userNotification.notification.occurredAt" />
    <q-btn
      v-show="isUnread"
      size="sm"
      label="Mark as read"
      :loading="isLoading"
      flat no-caps rounded
      @click.stop="markRead" />
  </component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import { UserNotification } from '@/type';
import { HasTaskMixin } from '@/mixins';
import HumanizeTime from '@/components/HumanizeTime.vue';
import PostImportComplete from './PostImportComplete.vue';
import PostSearchComplete from './PostSearchComplete.vue';
import UserActivated from './UserActivated.vue';
import AlbumFileGenerated from './AlbumFileGenerated.vue';
import AlbumFileNotGenerated from './AlbumFileNotGenerated.vue';
import SocialAccountAuthenticated from './SocialAccountAuthenticated.vue';
import FacebookAccountAuthenticated from './FacebookAccountAuthenticated.vue';
import InstagramAccountAuthenticated from './InstagramAccountAuthenticated.vue';
import SocialAccountAccessRevoked from './SocialAccountAccessRevoked.vue';
import SocialAccountDataDeletionRequested from './SocialAccountDataDeletionRequested.vue';
import ReportFileGenerated from './ReportFileGenerated.vue';
import ReportFileNotGenerated from './ReportFileNotGenerated.vue';
import { markAsRead } from './user-notification';
import componentMap from './UserNotifcationMap';

export default defineComponent({
  emits: ['marked-one-read'],
  mixins: [HasTaskMixin],
  props: {
    userNotification: {
      type: Object as () => UserNotification,
      required: true,
    },
  },
  computed: {
    isUnread(): boolean {
      return (this.userNotification.readAt === null);
    },
  },
  methods: {
    markRead(): void {
      this.task = markAsRead(this.userNotification.id);
      this.task.then(() => {
        const un = _.cloneDeep(this.userNotification);
        un.readAt = new Date().toDateString();
        this.$emit('marked-one-read', un);
      });
    },
    getComponentMap(type: string): string {
      // @ts-ignore
      return componentMap[type];
    },
  },
  components: {
    'post-import-complete': PostImportComplete,
    'post-search-complete': PostSearchComplete,
    'user-activated': UserActivated,
    'album-file-generated': AlbumFileGenerated,
    'album-file-not-generated': AlbumFileNotGenerated,
    'social-account-authenticated': SocialAccountAuthenticated,
    'facebook-account-authenticated': FacebookAccountAuthenticated,
    'instagram-account-authenticated': InstagramAccountAuthenticated,
    'social-account-access-revoked': SocialAccountAccessRevoked,
    'social-account-data-deletion-requested': SocialAccountDataDeletionRequested,
    'report-file-generated': ReportFileGenerated,
    'report-file-not-generated': ReportFileNotGenerated,
    'humanize-time': HumanizeTime,
  },
});
</script>
